export default class event {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/event/directives/event.html'),
            scope: {
                event: '='
            },
            controller: EventItemCtrl,
            controllerAs: 'item'
        }
    }
};

class EventItemCtrl {
    constructor($scope, $state, $filter, $stateParams, $timeout, $window, Sogeti, SweetAlert, Event, Events) {
        this._scope = $scope;
        this._state = $state;
        this._translator = $filter('translate');
        this._filter = $filter;
        this._stateParams = $stateParams;
        this._timeout = $timeout;
        this._window = $window;

        this.eventRepo = Event;
        this.alerter = SweetAlert;
        this.sogeti = Sogeti;
        this.eventHandler = Events;

        this.originalName = angular.copy(this._scope.event.name);
        if (this._scope.event.metadata.data) {
            this._scope.event.showSettingsButton = this.showSettingsButton(this._scope.event);
            this.originalTopic = angular.copy(this._scope.event.metadata.data.topic);
        }

        this.isSogetiAccount = this.sogeti.isSogetiAccount(this._scope.event.account_id);
        this.isMaximized = (this._window.localStorage.getItem('settings.event.expanded') == this._scope.event.id);
        this.showScheduler = false;
        this.page = {publish_at: moment()};
        this.pagePublishDates = [];
        this.publishDate = [];
        this.publishTime = [];
        this.showTemplates = false;
        this._scope.$on('event:settings:saved', () => {
            this.eventRepo.find(this._scope.event.id).then((event) => {
                this._scope.event = event.data;
                this._scope.event.showSettingsButton = this.showSettingsButton(this._scope.event);
                this.recipientString = ''; // May need rebuilding.
                this.formatEventDate();

                if (this.topicIsSelected()) {
                    this.isMaximized = true;
                }

                if (this.originalTopic != event.data.metadata.data.topic) {
                    this._scope.$broadcast('event:templates:topic_changed', {
                        event: this._scope.event,
                        topicId: this._scope.event.metadata.data.topic
                    });
                    this.showTemplates = true;
                    this.originalTopic = angular.copy(this._scope.event.metadata.data.topic);
                }
            });
        });

        this._scope.$on('event:update', () => { // Fetch a fresh copy.
            this.eventRepo.find(this._scope.event.id).then((event) => {
                this._scope.event = event.data;
                this._scope.event.showSettingsButton = this.showSettingsButton(event.data);
            });
        });

        this._scope.$on('event:settings:closed', () => {
            this.eventRepo.find(this._scope.event.id).then((event) => {
                this._scope.event = event.data;
                this._scope.event.showSettingsButton = this.showSettingsButton(event.data);
            });
        });

        this._scope.$on('event:template:selected', () => {
            this.eventRepo.generateMessages(this._scope.event.id).then((response) => {
                this._window.localStorage.setItem('settings.event.expanded', this._scope.event.id);
                this._scope.event = response.data;
                this._scope.event.showSettingsButton = this.showSettingsButton(response.data);
                this.showTemplates = false;
                this.prepareFlow();

                this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:MESSAGES_GENERATED'));
            }, (error) => {
                // Show template selector again.
                this.showTemplates = true;

                this.alerter.swal({
                    title: this._translator('EVENT:TEMPLATE:INCOMPATIBLE_HEADER'),
                    text: this._translator('EVENT:TEMPLATE:INCOMPATIBLE_BODY'),
                    type: 'error'
                });
            });
        });

        this._scope.$on('event:templates:closed', (event, data) => {
            this.showTemplates = false;
            this._scope.event = data.event;
            this._scope.event.showSettingsButton = this.showSettingsButton(data.event);

            this.prepareFlow();
        });

        this._scope.$on('event:dispatcher:removed', (event, data) => {
            let dispatchers = data.dispatcherType == 'campaign' ? this._scope.event.campaigns : this._scope.event.automations;

            angular.forEach(dispatchers, (dispatcher, index) => {
                if (dispatcher.id == data.dispatcherId) {
                    dispatchers.splice(index, 1);
                    this.prepareFlow();
                }
            });
        });

        this._scope.$on('event:dispatcher:added', (event, data) => {
            this._scope.event = data;
            this._scope.event.showSettingsButton = this.showSettingsButton(data);
            this.prepareFlow();
        });

        this._scope.$on('event:page:publish', (event, data) => {
            this.page.publish_at = data['publishAt'];
            this.publishPage();
        });

        this.prepareFlow();
    }

    insertCampaign(campaign) {
        if (campaign['pivot']['event_dispatcher_type_id'] == 1) { // Invitation
            this.invitation = campaign;
        } else if (campaign['pivot']['event_dispatcher_type_id'] == 3) { // Non RSVP message
            this.rsvpMessages.push(campaign);
        } else if (campaign['pivot']['event_dispatcher_type_id'] == 4) { // Attendance message
            this.attendanceMessages.push(campaign);
        } else if (campaign['pivot']['event_dispatcher_type_id'] == 6) { // Cancellation message
            this.cancellation = campaign;
        } else {
            this.postEvents.push(campaign);
        }
    };

    formatEventDate() {
        let metaData = this._scope.event.metadata ? this._scope.event.metadata.data : null;
        let startDate = moment(this._scope.event.start_date);
        let endDate = moment(this._scope.event.end_date);

        if (metaData && metaData.start_date_changed_to && metaData.end_date_changed_to) {
            startDate = moment(metaData.start_date_changed_to);
            endDate = moment(metaData.end_date_changed_to);
        }

        let isSameDayEvent = startDate.date() == endDate.date();
        let sDate = startDate.format('YYYY-MM-DD');
        let sTime = startDate.format('HH:mm');
        this.eventDate = sDate + ' ' + this._translator('TIME:AT') + ' ' + sTime;

        if (isSameDayEvent) {
            this.eventDate += ' - ' + endDate.format('HH:mm');
        } else {
            let eDate = endDate.format('YYYY-MM-DD');
            let eTime = endDate.format('HH:mm');
            this.eventDate += ' - ' + eDate + ' ' + this._translator('TIME:AT') + ' ' + eTime;
        }
    };

    prepareFlow() {
        this.attendanceMessages = [];
        this.rsvpMessages = [];
        this.postEvents = [];
        this.automations = this._scope.event.automations;

        if (this._scope.event.campaigns.length == 0) {
            this.showTemplates = true;
        }

        this.formatEventDate();

        angular.forEach(this._scope.event.campaigns, (campaign) => {
            this.insertCampaign(campaign);
        });

        this.numRows = this.attendanceMessages.length >= this.rsvpMessages.length ? this.attendanceMessages.length : this.rsvpMessages.length;

        this._timeout(() => {
            this._scope.$broadcast('event:updateSchedule');
        });

        if (this._stateParams.folder == 'current' && !this.counts && this.isMaximized) {
            this.eventRepo.getFlowStatistics(this._scope.event.id).then((data) => {
                this.counts = data;
            });
        }
    };

    deleteEvent() {
        this.alerter.swal({
            title: this._translator('EVENT:FLASH:DELETE_EVENT_HEADER'),
            text: this._translator('EVENT:FLASH:DELETE_EVENT_BODY'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this._translator('GLOBAL:YES'),
            cancelButtonText: this._translator('GLOBAL:NO')
        }, (isConfirm) => {
            if (isConfirm) {

                if (
                    this._scope.event.pages !== undefined
                    && this._scope.event.pages.episubscription !== undefined
                    && this._scope.event.pages.episubscription.status !== undefined
                    && this._scope.event.pages.episubscription.status != 0
                ) {
                    this.page.publish_at = "2070-09-06T08:46:00.000Z";
                    let data = angular.fromJson(this._scope.event.pages.episubscription.data);
                    data.metadata.publish_at = this.page.publish_at;

                    this.eventRepo.savePage(this._scope.event.id, "episubscription", data).then(() => {
                        this.eventRepo.publishPage(this._scope.event.id, "episubscription").then((response) => {
                            this.eventRepo.remove(this._scope.event.id).then(() => {
                                this._scope.$emit('event:removed');
                                this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:DELETED'));
                            }, (error) => {
                                this.eventHandler.flashEvent('error', this._translator('EVENT:FLASH:DELETE_FAILED'));
                            });
                        });
                    });
                } else {
                    this.eventRepo.remove(this._scope.event.id).then(() => {
                        this._scope.$emit('event:removed');
                        this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:DELETED'));
                    }, (error) => {
                        this.eventHandler.flashEvent('error', this._translator('EVENT:FLASH:DELETE_FAILED'));
                    });
                }
            }
        })
    }

    addSubscribers() {
        this._scope.$broadcast('event:inviteMore:show', {event: this._scope.event});
    };

    topicIsSelected() {
        let meta = this._scope.event.metadata.data;
        return meta.topic && meta.topic > 0;
    }

    baseSetupDone() {
        let startDate = moment(this._scope.event.start_date);
        let endDate = moment(this._scope.event.end_date);
        let now = moment();
        let hasRecipients = this._scope.event.segments.length || this._scope.event.tags.length || this._scope.event.subscribers.length;
        let dateSetup = (this._scope.event.event_status_id == 1 || this._scope.event.event_status_id == 4) ? startDate > now && endDate > now : true;
        return hasRecipients && this._scope.event.name.length > 0 && dateSetup && this._scope.event.name.length;
    }

    setupDone() {
        if (this.baseSetupDone() && this.isSogetiAccount) {
            let meta = this._scope.event.metadata.data;
            let hasResponsible = meta.responsible && meta.responsible.length > 0;
            let hasTopic = meta.topic && meta.topic > 0;
            let hasCountry = meta.country && meta.country.length > 0;
            let hasDivision = meta.division && meta.division.length > 0;
            let hasOffice = meta.office && meta.office.length > 0;
            let hasPlace = meta.place && meta.place.length > 0;
            let hasSenderName = meta.sender_name;
            let hasSenderEmail = meta.sender_email;
            let hasLanguage = meta.office && meta.office.length > 0;

            return hasResponsible
                && hasTopic
                && hasCountry
                && hasDivision
                && hasOffice
                && hasPlace
                && hasSenderName
                && hasSenderEmail
                && hasLanguage;
        } else {
            return this.baseSetupDone();
        }
    };

    formatEventPageDate(pageTypeName, publishAt) {
        this.pagePublishDates[pageTypeName] = publishAt ? publishAt : angular.fromJson(this._scope.event.pages[pageTypeName].data).metadata.publish_at;

        this.publishDate[pageTypeName] = moment(this.pagePublishDates[pageTypeName]).format('YYYY-MM-DD');

        this.publishTime[pageTypeName] = {
            hour: moment(this.pagePublishDates[pageTypeName]).format('HH'),
            minutes: moment(this.pagePublishDates[pageTypeName]).format('mm')
        };
    };

    eventPageStatus() {
        if (this.isSogetiAccount && this._scope.event.pages.episubscription && this._scope.event.pages.episubscription.published) {
            if (!this.pagePublishDates['episubscription']) {
                this.formatEventPageDate('episubscription');
            }

            return moment(this.pagePublishDates['episubscription']) > moment() ? 'scheduled' : 'published';
        } else {
            return 'non-scheduled';
        }
    };

    surveyPageStatus() {
        if (this.isSogetiAccount && this._scope.event.pages.episurvey && this._scope.event.pages.episurvey.published) {
            if (!this.pagePublishDates['episurvey']) {
                this.formatEventPageDate('episurvey');
            }

            return moment(this.pagePublishDates['episurvey']) > moment() ? 'scheduled' : 'published';
        } else {
            return 'non-scheduled';
        }
    };

    eventPageVisitUrl() {
        if (this.isSogetiAccount && this._scope.event.pages.episubscription) {
            return this._scope.event.pages.episubscription.visit_url;
        }
    };

    surveyPageVisitUrl() {
        if (this.isSogetiAccount && this._scope.event.pages.episurvey) {
            return this._scope.event.pages.episurvey.visit_url;
        }
    };

    togglePublishScheduler(type) {
        this.type = type;
        this._scope.$broadcast('event:page:showScheduler', {event: this._scope.event, type: this.type});
    };

    publishPage() {
        let data = angular.fromJson(this._scope.event.pages[this.type].data);
        data.metadata.publish_at = this.page.publish_at;

        this.eventRepo.savePage(this._scope.event.id, this.type, data).then(() => {
            this.alerter.swal({
                title: this._translator('EVENT:FLASH:EVENT_PAGE_SENDING_HEADER'),
                text: this._translator('EVENT:FLASH:EVENT_PAGE_SENDING_BODY'),
                type: 'info'
            });

            this.eventRepo.publishPage(this._scope.event.id, this.type).then((response) => {
                if (response.code > 0) {
                    $('.showSweetAlert, .sweet-overlay').fadeOut();
                    $('body').removeClass('stop-scrolling');
                    this._scope.event.pages[this.type].status = response.code;
                    this.formatEventPageDate(this.type, this.page.publish_at);
                    this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:EVENT_PAGE_GENERATED'));
                } else {
                    this.alerter.swal({
                        title: this._translator('EVENT:FLASH:PUBLISH_FAILED_HEADER'),
                        text: this._translator('EVENT:FLASH:PUBLISH_FAILED_BODY'),
                        type: 'error'
                    });
                }
            }, (error) => {
                if (error.status == 404) {
                    this.alerter.swal({
                        title: this._translator('EVENT:FLASH:IMAGES_MISSING_HEADER'),
                        text: this._translator('EVENT:FLASH:IMAGES_MISSING_BODY'),
                        type: 'error'
                    });
                } else {
                    this.alerter.swal({
                        title: this._translator('EVENT:FLASH:PUBLISH_FAILED_HEADER'),
                        text: this._translator('EVENT:FLASH:PUBLISH_FAILED_BODY'),
                        type: 'error'
                    });
                }
            });
        });
    };

    toggleMaximized(event) {
        if ($(event.target).is('span.label, span.fa, span.line-icon, button, input')) {
            return event.stopPropagation(); // Shouldn't open the event on these clicks..
        }

        if (!this.isMaximized && !this.topicIsSelected()) {
            return this.eventHandler.flashEvent('error', this._translator('EVENT:FLASH:SETUP_INCOMPLETE'));
        }

        this.isMaximized = !this.isMaximized;

        if (this.isMaximized) {
            this._window.localStorage.setItem('settings.event.expanded', this._scope.event.id);

            if (this._stateParams.folder == 'current') {
                this.eventRepo.getFlowStatistics(this._scope.event.id).then((data) => {
                    this.counts = data;
                });
            }

            this._timeout(() => {
                this._scope.$broadcast('event:updateSchedule');
            });
        } else {
            this._window.localStorage.removeItem('settings.event.expanded');
        }
    };

    showEventSettings() {
        this._scope.$broadcast('event:settings:show', {event: this._scope.event});
    };

    cancel() {
        this.alerter.swal({
            title: this._translator('EVENT:INDEX:CANCEL'),
            text: this._translator('EVENT:FLASH:CANCEL_BODY'),
            type: 'input',
            showLoaderOnConfirm: true,
            inputPlaceholder: this._translator('EVENT:FLASH:CANCEL_TEXT_PLACEHOLDER'),
            showCancelButton: true,
            closeOnConfirm: false,
            confirmButtonText: this._translator('EVENT:FLASH:DO_CANCEL'),
            cancelButtonText: this._translator('GLOBAL:CLOSE')
        }, (input) => {
            if (input === "") {
                this.alerter.showInputError(this._translator('EVENT:FLASH:CANCEL_INPUT_EMPTY'));
                return false;
            } else if (input && input.length > 0) {
                this.eventRepo.cancel(this._scope.event.id, input).then(() => {
                    this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:CANCELLED'));
                    this._state.go(this._state.current.name, {folder: 'cancelled'});
                    this.alerter.close();
                }, (error) => {
                    this.alerter.close();
                });
            }
        });
    };

    nameChangedAndValid() {
        return this._scope.event.name.length && this._scope.event.name != this.originalName;
    };

    updateName() {
        if (this.nameChangedAndValid()) {
            this.eventRepo.update(this._scope.event).then(() => {
                this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:NAME_UPDATED'));

                if ((!this.originalName || !this.originalName.length) && this._stateParams.folder == 'draft' || !this._stateParams.folder) {
                    this.showEventSettings();
                }

                this.originalName = angular.copy(this._scope.event.name);
            });
        }
    };

    toEventPage() {
        this._state.go('event.editPage', {type: 'episubscription', id: this._scope.event.id});
    };

    toSurveyPage() {
        this._state.go('event.editPage', {type: 'episurvey', id: this._scope.event.id});
    };

    toEventStatistics() {
        this._state.go('event.show', {id: this._scope.event.id});
    };

    sortSchedules() {
        this.attendanceMessages = this._filter('orderBy')(this.attendanceMessages, 'schedule.date');
        this.rsvpMessages = this._filter('orderBy')(this.rsvpMessages, 'schedule.date');
    };

    addDispatcher(type) {
        this.eventRepo.addDispatcher(this._scope.event.id, type).then((event) => {
            this._scope.event = event.data;
            this._scope.event.showSettingsButton = this.showSettingsButton(event.data);

            this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:UPDATED'));
            this.prepareFlow();
        });
    };

    showSettingsButton(event) {
        let metaData = event.metadata ? event.metadata.data : null;

        if ((metaData.start_date_changed_to !== undefined && metaData.start_date_changed_to !== event.start_date)
            || (metaData.end_date_changed_to !== undefined && metaData.end_date_changed_to !== event.end_date)
            || metaData.time_changed_to
            || metaData.place_changed_to
        ) {
            return false;
        }

        return [1, 4, 2].includes(event.event_status_id);
    }
}
